import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { DevFlag, type DevFlagsMap } from '@core/dev-flags-types';

import { DevFlagSelectors } from './store/dev-flags.store';

const initialState: DevFlagsMap = Object.values(DevFlag).reduce(
  (acc, curr) => {
    acc[curr] = false;
    return acc;
  },
  <DevFlagsMap>{},
);

export const injectDevFlagsMap = () => {
  let map: DevFlagsMap = initialState;
  inject(Store)
    .select(DevFlagSelectors.data)
    .pipe(filterDefined, take(1))
    .subscribe(data => {
      map = data;
    });
  return map;
};
